import MaintenanceWorkflowForwardingCheckinEntrySection from "../../../sections/CheckinEntry";
import MaintenanceWorkflowForwardingDirectiveEntryDiagnosticEntry from "../../../sections/DirectiveEntry/entries/DiagnosticEntry";

const DiagnosticEntryOnGoingCheckin = () => {
  return (
    <>
      <MaintenanceWorkflowForwardingCheckinEntrySection
        showTransportAutoEntriesDeliveryCodeWithComplete
      />

      <MaintenanceWorkflowForwardingDirectiveEntryDiagnosticEntry />
    </>
  );
}

export default DiagnosticEntryOnGoingCheckin;
